export default "__VITE_ASSET__CfV0IPxY__";